<template>
	<div class="contentHome">
		<div class="centerPage">
			<tabCommon></tabCommon>
			<div class="right">
				<p class="title">个人信息</p>
				<div class="formUserInfo">
					<el-form
							ref="baseData"
							class="info"
							:model="user"
							:rules="rules"
							:hide-required-asterisk="true"
							label-width="80px"
							label-suffix="：">
						<el-upload
								class="avatar-uploader"
								:action="headImgUploadUrl"
								:auto-upload="false"
								:show-file-list="false"
								name="uploadFile" :on-change="changeUpload">
							<div :style="'backgroundImage: url('+user.headImgPath+')'" class="avatar"></div>
							<span class="uploaderIcon">修改头像</span>
						</el-upload>
						
						<!-- vueCropper 剪裁图片实现-->
						<el-dialog title="图片剪裁" :visible.sync="dialogVisible" :close-on-press-escape="false"
											 :close-on-click-modal="false" append-to-body>
							<div class="cropper-content">
								<div class="cropper" style="text-align:center">
									<vueCropper
											ref="cropper"
											:img="option.img"
											:outputSize="option.size"
											:outputType="option.outputType"
											:info="true"
											:canScale="option.canScale"
											:autoCrop="option.autoCrop"
											:autoCropWidth="option.autoCropWidth"
											:autoCropHeight="option.autoCropHeight"
											:fixedBox="option.fixedBox"
											:fixed="option.fixed"
											:fixedNumber="option.fixedNumber"
											:canMove="option.canMove"
											:canMoveBox="option.canMoveBox"
											:original="option.original"
											:centerBox="option.centerBox"
											:infoTrue="option.infoTrue"
											:full="option.full"
											:enlarge="option.enlarge"
											:mode="option.mode">
									</vueCropper>
								</div>
							</div>
							<div slot="footer" class="dialog-footer">
								<el-button @click="dialogVisible = false">取消</el-button>
								<el-button type="primary" @click="finish" :loading="loading">确认</el-button>
							</div>
						</el-dialog>
						
						<p class="tit">基本信息</p>
						<div class="flex">
							<el-form-item label="真实姓名" prop="fullName">
								<el-input v-model="user.fullName" clearable placeholder="真实姓名" maxlength="12" show-word-limit></el-input>
							</el-form-item>
							<el-form-item label="性别">
								<el-radio-group v-model="user.gender" class="sex">
									<el-radio :label="1">男</el-radio>
									<el-radio :label="0">女</el-radio>
								</el-radio-group>
							</el-form-item>
						</div>
						<el-form-item label="年龄" prop="age">
							<el-input v-model.number="user.age" placeholder="年龄" maxlength="3" oninput="value=value.replace(/[^\d]/g,'')">
								<i slot="suffix" class="el-input__icon">岁</i>
							</el-input>
						</el-form-item>
						
						
						<el-form-item label="所在国家" prop="country">
							<el-input v-model="user.country" clearable style="width: 400px;" placeholder="所在国家" maxlength="30" show-word-limit></el-input>
						</el-form-item>
						
						<el-form-item label="所在省份" prop="abodeProvince">
							<el-input v-model="user.abodeProvince" clearable style="width: 400px;" placeholder="所在省份" maxlength="30" show-word-limit></el-input>
						</el-form-item>
						
						
						<el-form-item label="所在城市" prop="abodeCity">
							<el-input v-model="user.abodeCity" clearable style="width: 400px;" placeholder="所在城市" maxlength="30" show-word-limit></el-input>
						</el-form-item>
						<el-form-item label="手机号码">
							<el-input type="tel" v-model="user.mobile " style="width: 400px;" clearable
												oninput="value=value.replace(/[^\d]/g,'')"
                        maxlength="11"
												placeholder="手机号码"></el-input>
						</el-form-item>
						<el-form-item label="邮箱账号" prop="email">
							<el-input v-model="user.email " style="width: 400px;" clearable maxlength="255"
												placeholder="邮箱账号"></el-input>
						</el-form-item>
						<el-form-item label="职业" prop="workJob">
							<el-input v-model="user.workJob" clearable placeholder="职业" maxlength="50" show-word-limit></el-input>
						</el-form-item>
						<p class="tit">健康信息</p>
						<div class="flex">
							<el-form-item label="身高" prop="height">
								<el-input v-model="supplement.height" placeholder="身高" oninput="value=value.replace(/[^0-9.]/g,'')"
													maxlength="10">
									<i slot="suffix" class="el-input__icon">cm</i>
								</el-input>
							</el-form-item>
							<el-form-item label="体重" prop="weight">
								<el-input v-model="supplement.weight" placeholder="体重" oninput="value=value.replace(/[^0-9.]/g,'')"
													maxlength="10">
									<i slot="suffix" class="el-input__icon">Kg</i>
								</el-input>
							</el-form-item>
						</div>
						<div class="flex">
							<el-form-item label="血型" prop="bloodType">
								<el-input v-model="supplement.bloodType" clearable placeholder="血型" maxlength="50"></el-input>
							</el-form-item>
						
						</div>
						<div class="flex">
							<el-form-item label="上压" prop="bloodUpperPressure">
								<el-input v-model="supplement.bloodUpperPressure" placeholder="上压" maxlength="50">
									<i slot="suffix" class="el-input__icon">mmHg</i>
								</el-input>
							</el-form-item>
							<el-form-item label="下压" prop="bloodLowerPressure">
								<el-input v-model="supplement.bloodLowerPressure" placeholder="低压" maxlength="50">
									<i slot="suffix" class="el-input__icon">mmHg</i>
								</el-input>
							</el-form-item>
						</div>
						<div class="flex underlyingD">
							<el-form-item label="基础病" prop="other">
								<el-input v-model="supplement.other" style="width: 400px;" clearable maxlength="255"
													placeholder="基础病"></el-input>
							</el-form-item>
							<el-button @click="saveInfo('baseData')">保存</el-button>
						</div>
					</el-form>
					
					<el-form class="info" label-suffix="：" label-width="80px">
						<p class="tit">登录信息</p>
						<el-form-item label="登录手机">
							<span>{{loginInfo.mobile || '无'}}</span>
							<el-button type="primary" class="change-btn" @click="showChangeDialog('mobile')">更换</el-button>
						</el-form-item>
						<el-form-item label="登录邮箱">
							<span>{{loginInfo.email || '无'}}</span>
							<el-button type="primary" class="change-btn" @click="showChangeDialog('email')">更换</el-button>
						</el-form-item>
            <el-form-item label="所在企业">
              <span>{{corp.corpName}}</span>
              <el-button v-if="!corp.corpId" type="primary" class="change-btn" @click="openCorpApplyDialog">加入申请</el-button>
              <span class="corp-state" :state="corp.corpStatus" v-else>{{corp.corpStatus==1?'审核中':corp.corpStatus==2?'已加入':'-'}}</span>
            </el-form-item>
					</el-form>
					
					<el-form ref="invoice" class="info" :model="invoice" :rules="rules" label-width="80px" label-suffix="："
									 :hide-required-asterisk="true">
						<p class="tit">发票信息</p>
						<el-form-item label="发票抬头" prop="invoiceTitle">
							<el-input v-model="invoice.invoiceTitle " style="width: 400px;" clearable maxlength="255"
												placeholder="发票抬头"></el-input>
						</el-form-item>
						<!--<el-form-item label="发票编号" prop="invoiceNo">-->
						<!--	<el-input v-model="invoice.invoiceNo" clearable placeholder="发票编号"></el-input>-->
						<!--</el-form-item>-->
						<el-form-item label="收件人" prop="consignee">
							<el-input v-model="invoice.consignee" maxlength="255" clearable placeholder="收件人"></el-input>
						</el-form-item>
						<el-form-item label="手机号码" prop="mobile">
							<el-input v-model="invoice.mobile" clearable placeholder="手机号码" maxlength="11"
												oninput="value=value.replace(/[^\d]/g,'')"></el-input>
						</el-form-item>
						<div class="flex underlyingD">
							<el-form-item label="邮寄地址" prop="address">
								<el-input v-model="invoice.address" style="width: 400px;" clearable maxlength="255"
													placeholder="邮寄地址"></el-input>
							</el-form-item>
							<el-button @click="saveInvoice('invoice')">保存</el-button>
						</div>
					</el-form>
				</div>
			</div>
		</div>
		<ChangeLoginInfoDialog ref="changeLoginInfoDialog"></ChangeLoginInfoDialog>

<!--  企业申请dialog   -->
    <el-dialog title="加入企业申请"
               top="0"
               width="540px"
               :visible.sync="corpApplyDialog.visible"
               :close-on-click-modal="false">
      <el-form label-width="80px" v-model="corpApplyDialog.form">
        <el-form-item label="企业代码">
          <el-input v-model="corpApplyDialog.form.code"></el-input>
        </el-form-item>
        <el-form-item label="申请说明">
          <el-input type="textarea" :rows="3" v-model="corpApplyDialog.form.applyExplain"></el-input>
        </el-form-item>
      </el-form>
      <div style="text-align: right">
        <el-button type="primary" @click="doCorpApply">提交申请</el-button>
        <el-button @click="corpApplyDialog.visible=false">取消</el-button>
      </div>


    </el-dialog>
	
	</div>
</template>

<script>
  import base from '@/api/common';
  // 使用vue-cropper 图片上传组件
  import {VueCropper} from 'vue-cropper';
  import commonjs from "../../api/common";
  import qs from 'qs'

  import axios from 'axios';
  import ChangeLoginInfoDialog from '@/components/common/ChangeLoginInfo'

  export default {
    name: "userCenter",
    data() {
      return {
        headImgUploadUrl: base.headImgUploadUrl || '',
        user: {},
        supplement: {},
        invoice: {},
        rules: {
          fullName: [
            {required: true, message: '请输入名字', trigger: 'blur'},
            {max: 50, message: '长度过长', trigger: 'blur'}
          ],
          age: [
            {required: true, message: '年龄不能为空', trigger: 'blur'},
          ],
          abodeCity: [
            {max: 50, message: '长度过长', trigger: 'blur'}
          ],
          workJob: [
            {max: 50, message: '长度过长', trigger: 'blur'}
          ],
          email: [
            {required: true, message: '邮箱不能为空', trigger: 'blur'},
            {type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur'},
            {max: 50, message: '长度过长', trigger: 'blur'},
          ],
          invoiceTitle: [
            {required: true, message: '抬头不能为空', trigger: 'blur'},
            {max: 50, message: '长度过长', trigger: 'blur'}
          ],
          // invoiceNo: [
          // 	{required: true, message: '编号不能为空', trigger: 'blur'},
          // 	{max: 30, message: '长度过长', trigger: 'blur'}
          // ],
          consignee: [
            {required: true, message: '收件人不能为空', trigger: 'blur'},
            {max: 50, message: '长度过长', trigger: 'blur'}
          ],
          mobile: [
            {required: true, message: '手机号码不能为空', trigger: 'blur'},
            {min: 11, max: 11, message: '长度为11位', trigger: 'blur'}
          ],
          address: [
            {required: true, message: '地址不能为空', trigger: 'blur'},
            {max: 50, message: '长度过长', trigger: 'blur'}
          ],
        },

        fileImg: '',
        dialogVisible: false,
        // 裁剪组件的基础配置option
        option: {
          img: '', // 裁剪图片的地址
          outputSize: 0.8, // 裁剪生成图片的质量
          outputType: 'jpeg', // 裁剪生成图片的格式
          info: true, // 裁剪框的大小信息
          canScale: true, // 图片是否允许滚轮缩放
          autoCrop: true, // 是否默认生成截图框
          autoCropWidth: 100, // 默认生成截图框宽度
          autoCropHeight: 100, // 默认生成截图框高度
          fixedBox: false, // 固定截图框大小 不允许改变
          fixed: true, // 是否开启截图框宽高固定比例
          fixedNumber: [100, 100], // 截图框的宽高比例
          canMove: true, // 上传图片是否可以移动
          canMoveBox: true, // 截图框能否拖动
          original: false, // 上传图片按照原始比例渲染
          centerBox: true, // 截图框是否被限制在图片里面
          infoTrue: true, // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
          full: false, // 是否输出原图比例的截图
          enlarge: '1', // 图片根据截图框输出比例倍数
          mode: 'contain' // 图片默认渲染方式
        },
        // 防止重复提交
        loading: false,

        loginInfo: {
          email: '',
          mobile: ''
        },
        corp:{
          id: 0,
          corpStatus: 0,
          corpName: '',
        },
        corpApplyDialog:{
          visible: false,
          form:{
            code: '',
            applyExplain: ''
          }
        }
      }
    },
    components: {
      'tabCommon': () => import('./tabCommon'),
      VueCropper,
      ChangeLoginInfoDialog
    },
    inject: ['reload'],
    async mounted() {
      let vm = this;
      let currentUser = await base.utils.getCurrent();
      if (currentUser) {
        vm.$ajax.post(base.api.user.detail.replace('{uid}', currentUser.id))
            .then((res) => {
              if (res.data.status == 'success') {
                vm.user = res.data.data.user || {};
                vm.supplement = res.data.data.supplement || {userId: currentUser.id};
                vm.invoice = res.data.data.invoice || {userId: currentUser.id};
              }
            })
        // 登录信息
        vm.$ajax.post(base.basePath + 'sys/authorize/login-info').then(res => {
          if (res.data.status === 'success') {
            vm.loginInfo.email = res.data.data.email;
            vm.loginInfo.mobile = res.data.data.mobile;
          }
        });
        vm.loadCorp();
      }
    },
    methods: {
      loadCorp(){
        let vm = this;
        vm.$ajax.post(base.basePath + 'corp/corp-company/authorize/belong/corp-status').then(res=>{
          if(res.data.status === 'success'){
            console.log(res.data);
            vm.corp.corpId = res.data.corpId;
            vm.corp.corpStatus = res.data.corpStatus;
            vm.corp.corpName = res.data.corpName;
          }
        });
      },
      saveInfo(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let vm = this;
            let params = {
              user: vm.user,
              supplement: vm.supplement
            };
            vm.$ajax.post(base.api.user.edit + '?userId=' + vm.user.id, params)
                .then((res) => {
                  if (res.data.status === 'success') {
                    vm.$message.success('保存成功');
                  }
                })
          } else {
            this.$message.error("请检查所填字段");
            return false;
          }
        });
      },
      saveInvoice(formName) {
        let that = this;
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let vm = this;
            vm.$ajax.post(base.api.user.saveInvoice.replace("{userId}", vm.user.id), vm.invoice)
                .then((res) => {
                  if (res.data.status == 'success') {
                    vm.$message.success('保存成功');
                  } else {
                    vm.$message.success('保存失败')
                  }
                }).catch(err => {
              console.error(err);
              vm.$message.success('保存失败')
            })
          } else {
            this.$message.error("请检查所填字段");
            return false;
          }
        });
      },
      changeUpload(file, fileList) {
        const isLt5M = file.size / 1024 / 1024 < 5
        if (!isLt5M) {
          this.$message.error('上传文件大小不能超过 5MB!')
          return false
        }

        // 上传成功后将图片地址赋值给裁剪框显示图片
        this.$nextTick(() => {
          this.option.img = URL.createObjectURL(file.raw);
          this.dialogVisible = true
        })
      },
      // 点击裁剪，这一步是可以拿到处理后的地址
      finish() {
        let that = this;
        // 获取截图的base64 数据
        this.$refs.cropper.getCropData((data) => {
          // do something
          this.loading = true;
          // 把图片上传到服务器
          // setTimeout(() => {
          this.loading = false;
          this.dialogVisible = false;
          this.fileImg = data;

          let formData = new FormData();

          let arr = data.split(','), mime = arr[0].match(/:(.*?);/)[1],
              bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
          while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
          }
          formData.append('uploadFile', new File([u8arr], 'headImg.png', {type: mime}));

          axios.post(commonjs.basePath + 'auth/auth-user/authorize/update/headImg', formData)
              .then((res) => {
                if (res.data.status === 'success') {
                  that.user.headImgPath = res.data.message;
                  // 更新头像
									that.updateUserHeadImg();
                } else {
                  that.$message.error("头像上传失败");
                }
              })
          // }, 1000)
        });
      },
      updateUserHeadImg(){
				// 1.本地头像数据重置
        localStorage.setItem('headImg', this.user.headImgPath);
        // 2. 顶部头像替换
        $("#h_img img").attr('src', this.user.headImgPath);
        $("img#aside-tab-headImg").attr('src', this.user.headImgPath);
      },
      showChangeDialog(type) {
        this.$refs.changeLoginInfoDialog.dialogType = type;
        if (type === 'mobile') {
          this.$refs.changeLoginInfoDialog.dialogTitle = '更换手机号码';
          this.$refs.changeLoginInfoDialog.loginInfo.mobile = this.loginInfo.mobile;
        } else if (type === 'email') {
          this.$refs.changeLoginInfoDialog.dialogTitle = '更换邮箱';
          this.$refs.changeLoginInfoDialog.loginInfo.email = this.loginInfo.email;
        }
        this.$refs.changeLoginInfoDialog.dialogVisible = true;
      },
      openCorpApplyDialog(){
        this.corpApplyDialog.form.code = '';
        this.corpApplyDialog.form.applyExplain = '';
        this.corpApplyDialog.visible = true;
      },
      doCorpApply(){
        let code = this.corpApplyDialog.form.code;
        let explain = this.corpApplyDialog.form.applyExplain;
        if($.trim(code).length==0){ this.$message.warning('企业代码不能为空'); return; }
        if($.trim(explain).length==0){ this.$message.warning('说明不能为空'); return; }

        this.$ajax.post(base.basePath + 'corp/corp-user-apply/authorize/join/' + code, qs.stringify({explain})).then(res=>{
          if(res.data.status === 'success'){
            this.$message.success('提交成功');
            this.loadCorp();
            this.corpApplyDialog.visible = false;
          }else{
            this.$message.error(res.data.message);
          }
        }).catch(err=>{
          console.error(err);
          this.$message.error('提交失败');
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
	@import "../../assets/css/personalCenter.scss";
	
	/* 截图 */
	/* .cropper-content {} */
	.cropper {
		width: auto;
		height: 320px;
	}
	
	.right {
		.change-btn {
			margin-left: 12px;
			padding: 0 14px;
			height: 24px;
			line-height: 24px;
			font-size: 14px;
			color: #FFF;
			background-color: #409EFF;
			border-color: #409EFF;
			
			&:hover {
				color: #409EFF;
				border-color: #c6e2ff;
				background-color: #ecf5ff;
			}
		}
	}
span.corp-state{
  display: inline-block;
  width: 60px;
  height: 20px;
  line-height: 20px;
  margin-left: 8px;
  text-align: center;
  font-size: 12px;
}
span.corp-state[state='1']{ color: #e6a23c; background: #fdf6ec;}
span.corp-state[state='2']{ color: #67c23a; background: #f0f9eb;}
</style>
